import { render, staticRenderFns } from "./AddEditPostagemMidiaSociais.vue?vue&type=template&id=2865f36c&scoped=true"
import script from "./AddEditPostagemMidiaSociais.vue?vue&type=script&lang=js"
export * from "./AddEditPostagemMidiaSociais.vue?vue&type=script&lang=js"
import style0 from "./AddEditPostagemMidiaSociais.vue?vue&type=style&index=0&id=2865f36c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865f36c",
  null
  
)

export default component.exports